export const isEmail = (email: string) => {
  return new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(email);
};

const RESTRICTED_LOTTE_EMAIL_PATTERN = /^[a-zA-Z]{2}\d{5}@lotte\.net$/;

type EmailValidationRule = {
  validate: (email: string) => boolean;
  message: string;
};

const EMAIL_VALIDATION_RULES: EmailValidationRule[] = [
  {
    validate: (email) => isEmail(email),
    message: '이메일 형식을 확인해주세요',
  },
  {
    validate: (email) => !RESTRICTED_LOTTE_EMAIL_PATTERN.test(email),
    message: 'lotte.net 이메일은 store360을 통해서만 이용가능해요',
  },
];

/** 이메일 유효성 검사. 에러 메시지를 반환하고, 유효하면 null */
export const validateEmailInput = (email: string): string | null => {
  for (const rule of EMAIL_VALIDATION_RULES) {
    if (!rule.validate(email)) {
      return rule.message;
    }
  }
  return null;
};

export const isPassword = (password: string) => {
  return new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/).test(password);
};

export const isPassword2 = (password: string) => {
  return new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{4,20}$/).test(password);
};

export const isPasswordKey = (password: string) => {
  if (password.length === 0) return true;
  return new RegExp(/[A-Za-z\d!@#$%^&*()_+-=,.<>/?;:'"[\]{}|\\`~]{1,50}$/).test(password);
};
